import ar from '../locales/ar.js';
import en from '../locales/en.js';
import tr from '../locales/tr.js';

const locales = { en, ar, tr };
const rtlLocales = new Set(['ar']);
let currentLocale = 'en';
const listeners = new Set();

function getNestedValue(obj, path) {
    return path.split('.').reduce((acc, key) => (acc ? acc[key] : undefined), obj);
}

export function t(key, vars = {}) {
    const value = getNestedValue(locales[currentLocale], key);
    if (value === undefined || value === null) {
        return key;
    }

    if (typeof value !== 'string') {
        return value;
    }

    return value.replace(/{{\s*(\w+)\s*}}/g, (_, token) => {
        return vars[token] !== undefined ? String(vars[token]) : '';
    });
}

export function getLocale() {
    return currentLocale;
}

function applyTranslations() {
    document.querySelectorAll('[data-i18n]').forEach((el) => {
        const key = el.getAttribute('data-i18n');
        const value = t(key);
        if (typeof value === 'string') {
            el.textContent = value;
        }
    });

    document.querySelectorAll('[data-i18n-html]').forEach((el) => {
        const key = el.getAttribute('data-i18n-html');
        const value = t(key);
        if (typeof value === 'string') {
            el.innerHTML = value;
        }
    });

    document.querySelectorAll('[data-i18n-placeholder]').forEach((el) => {
        const key = el.getAttribute('data-i18n-placeholder');
        const value = t(key);
        if (typeof value === 'string') {
            el.setAttribute('placeholder', value);
        }
    });

    document.querySelectorAll('[data-i18n-value]').forEach((el) => {
        const key = el.getAttribute('data-i18n-value');
        const value = t(key);
        if (typeof value === 'string') {
            el.setAttribute('value', value);
        }
    });
}

function updateDocumentDirection() {
    const isRtl = rtlLocales.has(currentLocale);
    const html = document.documentElement;

    html.lang = currentLocale;
    html.dir = isRtl ? 'rtl' : 'ltr';

    const bootstrapLink = document.getElementById('bootstrapCss');
    if (bootstrapLink) {
        const ltrHref = bootstrapLink.getAttribute('data-ltr');
        const rtlHref = bootstrapLink.getAttribute('data-rtl');
        if (isRtl && rtlHref) {
            bootstrapLink.href = rtlHref;
        } else if (!isRtl && ltrHref) {
            bootstrapLink.href = ltrHref;
        }
    }
}

function updateLanguageDropdown() {
    const button = document.getElementById('langMenuButton');
    if (button) {
        const label = t(`nav.language.${currentLocale}`);
        button.textContent = label && label !== `nav.language.${currentLocale}`
            ? label
            : currentLocale.toUpperCase();
    }

    document.querySelectorAll('.lang-option').forEach((option) => {
        const isActive = option.getAttribute('data-lang') === currentLocale;
        option.classList.toggle('active', isActive);
    });
}

export function setLocale(locale, options = {}) {
    if (!locales[locale]) return;

    currentLocale = locale;
    applyTranslations();
    updateDocumentDirection();
    updateLanguageDropdown();

    if (options.persist !== false) {
        localStorage.setItem('locale', locale);
    }

    listeners.forEach((listener) => listener(locale));
}

export function initI18n() {
    const savedLocale = localStorage.getItem('locale');
    const browserLang = navigator.language?.toLowerCase() || '';
    const browserLocale = browserLang.startsWith('ar')
        ? 'ar'
        : browserLang.startsWith('tr')
            ? 'tr'
            : 'en';
    setLocale(savedLocale || browserLocale, { persist: false });

    const options = document.querySelectorAll('.lang-option');
    options.forEach((option) => {
        option.addEventListener('click', () => {
            const nextLocale = option.getAttribute('data-lang');
            setLocale(nextLocale);
        });
    });
}

export function onLocaleChange(callback) {
    listeners.add(callback);
    return () => listeners.delete(callback);
}
